// Text of a verbatim quote: whole, or cut at a word boundary with a control that shows the full
// text; ellipses mark excerpts that begin or end mid-sentence (see excerpt.ts).

import { useSignal } from '@preact/signals';
import { quoteView } from './excerpt.ts';

interface QuoteTextProps {
  quote: string;
  /** Characters shown before the cut; omitted = always whole. */
  limit?: number;
}

export function QuoteText({ quote, limit }: QuoteTextProps) {
  const open = useSignal(false);
  const cuttable = limit !== undefined && quoteView(quote, limit).hidden;
  const v = quoteView(quote, cuttable && !open.value ? limit : 'full');

  return (
    <>
      {v.lead}
      {v.text}
      {v.hidden ? null : v.tail}{' '}
      {cuttable ? (
        <button
          type="button"
          class="wc-quote-more"
          aria-expanded={open.value}
          title={open.value ? 'Shorten' : 'Show the full quote'}
          onClick={() => (open.value = !open.value)}
        >
          {open.value ? '(less)' : '[…]'}
        </button>
      ) : null}
    </>
  );
}
